import { render, staticRenderFns } from "./faceStudentstatisticsDel.vue?vue&type=template&id=6c2a0cb0"
import script from "./faceStudentstatisticsDel.vue?vue&type=script&lang=js"
export * from "./faceStudentstatisticsDel.vue?vue&type=script&lang=js"
import style0 from "./faceStudentstatisticsDel.vue?vue&type=style&index=0&id=6c2a0cb0&prod&lang=less&scope=true"
import style1 from "./faceStudentstatisticsDel.vue?vue&type=style&index=1&id=6c2a0cb0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports